module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Preferences"},"es":{"title":"Preferencias"},"fr":{"title":"Préférences"},"it":{"title":"Preferenze"},"pt":{"title":"Preferências"},"pl":{"title":"Preferencje"}}')
  delete Component.options._Ctor
}
